export enum TaskType {
  GENERAL_CASE = 'Case Task',
  WORKFLOW_STEP = 'Workflow Step',
  CASE_STEP_TASK = 'Case Step Task',
  COURT = 'Court'
}
